import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const routerEffectsActions = createActionGroup({
  source: 'Router Effects',
  events: {
    'Route board id changed': props<{ boardId: string }>(),
    'Route tenant id changed': props<{ tenantId: string }>(),
    'Editor tree view parameters set': emptyProps(),
  },
});
